import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DailySalesReportService {




  constructor(private http: HttpClient) { }
  getShopList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/common/shop/get', requestData);

  }
  
  getWeekNoList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/week-def/get', requestData);

  }
  getTerminalList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop/terminal/get', requestData);

  }
   getHqTerminalList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/daily-sales-report/get-terminals', requestData);

  }
  getUsers(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/user/get', requestData);
  }
  exportDailySalesReport(data: any): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/daily-sales-report/get',
      data,
      { responseType: 'blob' }
    );
  }

    getDailySalesReportViewList(requestData: any): Observable<any> {
      return this.http.post(environment.baseUrl+'/daily-sales-report/get', requestData);
  
    }
}
